import React from 'react';
import { useNavigate } from 'react-router-dom';

import { titleForPath } from '../utils/routeTitle';
import { useAuth } from '../context/AuthContext';

export function MobileTopbar({ pathname, onMenuToggle }) {
  const title = titleForPath(pathname);
  const navigate = useNavigate();
  const { username } = useAuth();

  return (
    <header className="mobile-topbar">
      <button
        type="button"
        className="mobile-topbar__menu"
        onClick={onMenuToggle}
        aria-label="Menüyü aç"
      >
        <span className="mobile-topbar__menu-icon" aria-hidden="true" />
      </button>
      <div className="mobile-topbar__title">{title}</div>
      {username ? (
        <button
          type="button"
          className="mobile-topbar__user"
          onClick={() => navigate('/hesap')}
          title="Hesap ayarları"
        >
          {username}
        </button>
      ) : null}
    </header>
  );
}
